import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomesticJourneyAgeVerificationComponent } from './domestic-journey-age-verification.component';
import { DateFormatModule, StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [DomesticJourneyAgeVerificationComponent],
  imports: [CommonModule, DateFormatModule, StaticMsgModule],
  exports: [DomesticJourneyAgeVerificationComponent],
})
export class DomesticJourneyAgeVerificationModule {}
